import { useMemo } from 'react';
import { Box, Pagination } from '@mui/material';
import { useSearchParams } from 'react-router-dom';

export const usePaginationControls = ({ pagesCount, loading }) => {
  const [params, setParams] = useSearchParams();
  const pageParam = +(params.get('page') || 1);

  const handlePageChange = (_, val) => {
    setParams((prev) => {
      prev.set('page', val);
      return prev;
    });

    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const paginationComponent = useMemo(() => {
    if (pagesCount > 1 && !loading) {
      return (
        <Box
          sx={{ minHeight: '100px' }}
          className="w-100 d-flex justify-content-center align-items-center"
        >
          <Pagination
            count={pagesCount}
            size="small"
            siblingCount={3}
            onChange={handlePageChange}
            page={pageParam}
          />
        </Box>
      );
    }
    return null;
  }, [pagesCount, loading, pageParam]);

  return { paginationComponent, pageParam };
};
